import { createFileRoute } from "@tanstack/react-router";
import { PolicyPage } from "../components/policy-page";
import { loadPolicy, policyHead } from "../lib/policy-route";

/** /terms: the creator's policy page on their site, Drate's own Terms page on drate.app. */
export const Route = createFileRoute("/terms")({
  loader: () => loadPolicy("/terms"),
  head: ({ matches, loaderData, match }) => policyHead(matches, loaderData, match.pathname),
  component: () => <PolicyPage data={Route.useLoaderData()} />,
});
